import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Button, Menu, MenuItem, IconButton,
} from '@material-ui/core';
import TrackedLink from './TrackedLink';

const styles = () => ({

    linkMenu: {
        top: 40,
    },
});

class LinkMenu extends React.Component {
    state = {
        anchorEl: null,
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const {
            classes, icon, label, links,
        } = this.props;
        const { anchorEl } = this.state;

        return (
            <div>
                {icon ? (
                    <IconButton
                        color="inherit"
                        aria-owns={anchorEl ? 'link-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                    >
                        {icon}
                    </IconButton>
                ) : (
                    <Button
                        aria-owns={anchorEl ? 'link-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                    >
                        {label}
                    </Button>
                )}
                <Menu
                    id="link-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    className={classes.linkMenu}
                >
                    {links.map(link => (
                        <TrackedLink to={link.to} key={link.to} label={link.label}>
                            <MenuItem onClick={this.handleClose}>{link.text}</MenuItem>
                        </TrackedLink>
                    ))}
                </Menu>
            </div>
        );
    }
}

LinkMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    links: PropTypes.array.isRequired,
    icon: PropTypes.node,
    label: PropTypes.string,
};

LinkMenu.defaultProps = {
    icon: null,
    label: null,
};

const WithRef = withStyles(styles)(LinkMenu);

export default React.forwardRef((props, ref) => <WithRef {...props} forwardedRef={ref} />);
